import Button from '@jetbrains/ring-ui/components/button/button'
import plur from 'plur'
import {useState} from 'react'

import {getSingleProjectArg} from '../../../../../rest/projects'
import {isArchivedProject} from '../../../../../selectors'
import {restApi} from '../../../../../services/rest'
import {emptyArray} from '../../../../../utils/empty'
import styles from '../Subprojects.css'

import {
  ArchivedSubprojects,
  archivedSubprojectsArg,
} from './ArchivedSubprojects/ArchivedSubprojects'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  projectId: string
}
function ArchivedSubprojectsToggle({projectId}: Props) {
  const projectArchived = useAppSelector(state => isArchivedProject(state, projectId))
  const {archivedProjectIds} = restApi.endpoints.getProjectNormalized.useQuery(
    getSingleProjectArg(projectId),
    {
      selectFromResult: ({data}) => ({
        archivedProjectIds: data?.entities.projectArchivedSubprojectsIds?.[projectId] ?? emptyArray,
      }),
    },
  )
  const {archivedSubprojectLoaded} = restApi.endpoints.getAllProjectsNormalized.useQueryState(
    archivedSubprojectsArg,
    {selectFromResult: ({data}) => ({archivedSubprojectLoaded: data != null})},
  )
  const countArchivedSubprojects = archivedProjectIds.length
  const [showArchived, setShowArchived] = useState(false)
  return (
    <>
      {!projectArchived &&
      (!archivedSubprojectLoaded || !showArchived) &&
      countArchivedSubprojects ? (
        <Button onClick={() => setShowArchived(true)} className={styles.showArchivedProjectsButton}>
          {`Show ${countArchivedSubprojects} archived ${plur('project', countArchivedSubprojects)}`}
        </Button>
      ) : null}
      {(projectArchived || showArchived) && countArchivedSubprojects > 0 && (
        <ArchivedSubprojects projectId={projectId} onHide={() => setShowArchived(false)} />
      )}
    </>
  )
}

export default ArchivedSubprojectsToggle
